import getCaptcha from "./getCaptcha.js";
import login from "./login.js";
import register from "./register.js";
import getUserInfo from "./user.js";
import market from "./market.js";
import order from "./order.js";

const api = {
  getCaptcha,
  login,
  register,
  getUserInfo,
  market,
  order
};


export default api;